// extracted by mini-css-extract-plugin
export var bContent = "TwoColList-module--bContent--a0339";
export var bList = "TwoColList-module--bList--890e1";
export var checkIconC = "TwoColList-module--checkIconC--435c6";
export var image = "TwoColList-module--image--191d0";
export var item = "TwoColList-module--item--39342";
export var listC = "TwoColList-module--listC--b881d";